export default "__VITE_ASSET__fosVmkaw__"